import { DiscountType } from '@ibk/shared-types';
export const DEFAULT_CURRENCY_VALUE = 'R$ 0,00';
export const applyMask = (value, type) => {
    const numbers = value.replace(/\D/g, '');
    if (type === DiscountType.TOTAL) {
        if (numbers === '')
            return DEFAULT_CURRENCY_VALUE;
        const formattedNumber = numbers.padStart(3, '0');
        const reais = formattedNumber.slice(0, -2);
        const centavos = formattedNumber.slice(-2);
        const formattedReais = parseInt(reais).toLocaleString('pt-BR');
        return `R$ ${formattedReais},${centavos}`;
    }
    else {
        if (numbers === '')
            return '0,00%';
        const digits = numbers.padStart(3, '0');
        const inteiros = digits.slice(0, -2);
        const decimais = digits.slice(-2);
        return `${parseInt(inteiros)},${decimais}%`;
    }
};
